<template>
  <message-dialog
    v-model="dialogOpen"
    card-class="q-dialog-plugin"
    :title="title"
    :persistent="persistent"
    @hide="$emit('hide')"
  >
    <q-item-label
      v-for="(m, k) in messages"
      :key="k"
      :class="m.labelClass || undefined"
    >
      {{ m.message }}
    </q-item-label>

    <template v-if="showBanner" #after>
      <page-banner
        dense
        dark
        color="red-7"
        class="q-mx-sm"
        :label="typeof banner === 'object' ? banner.message : banner"
        v-bind="typeof banner === 'object' ? banner : {}"
      />
    </template>

    <template #actions>
      <q-btn
        v-if="!!cancel"
        :color="cancelColor || 'black'"
        :label="cancel === true ? 'Cancel' : cancel"
        flat
        @click="onCancelClick"
      />
      <q-btn
        :color="color"
        :label="ok === true ? 'Continue' : (ok || 'OK')"
        flat
        autofocus
        @click="onOKClick"
      />
    </template>
  </message-dialog>
</template>

<script>
// This component is used for message dialogs called dynamically
// Refer to https://quasar.dev/quasar-plugins/dialog#Invoking-custom-component
export default {
  props: {
    title: {
      type: String
    },
    message: {
      type: [String, Array, Boolean],
      default: null
    },
    ok: {
      type: [Boolean, String]
    },
    cancel: {
      type: [Boolean, String]
    },
    persistent: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'blue'
    },
    cancelColor: {
      type: String
    },
    banner: {
      type: [String, Object, Boolean],
      default: null
    }
  },
  emits: [
    // REQUIRED
    'ok', 'hide'
  ],
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    messages () {
      if (!this.message) {
        return []
      }

      let messages = this.message
      if (!Array.isArray(messages)) {
        messages = [messages]
      }

      const regenMessages = []
      for (const item of messages) {
        if (typeof item === 'object' && typeof item.message === 'string') {
          regenMessages.push(item)
        }
        else if (typeof item === 'string') {
          regenMessages.push({
            message: item
          })
        }
      }
      return regenMessages
    },
    showBanner () {
      return !!this.banner && ((typeof this.banner === 'object' && typeof this.banner.message === 'string') || typeof this.banner === 'string')
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.dialogOpen = true
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.dialogOpen = false
    },
    onOKClick () {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok')
      // or with payload: this.$emit('ok', { ... })
      // then hiding dialog
      this.hide()
    },
    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>
